<span mat-dialog-title>{{ 'ACCOUNT.DELETE_PAYMENT_METHOD.TITLE' | translate }}</span>
<div mat-dialog-content>
  <p>{{ 'ACCOUNT.DELETE_PAYMENT_METHOD.INFO' | translate }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close="false" class="dark-plain-button">{{ 'GENERAL.CANCEL' | translate }}</button>
  <button mat-button mat-dialog-close="true" color="warn">
    {{ 'GENERAL.CONFIRM' | translate }}
  </button>
</div>
